import {createRequestDataSource} from '@ngneat/elf-requests';
import {selectCurrentPageEntities} from '@ngneat/elf-pagination';

import {purchaseStatementsStore} from '@store/invoices/purchaseStatements/purchaseStatements.store';

export const getPurchaseStatementsDataSource = createRequestDataSource({
  store: purchaseStatementsStore,
  data$: () => purchaseStatementsStore.pipe(selectCurrentPageEntities()),
  requestKey: 'getPurchaseStatements',
  dataKey: 'purchaseStatements',
});